<div>
  <span class="emoji">{{ getEmoji() }}</span> <span class="code">{{ data }}</span>
</div>
